import { Component, Input, EventEmitter, Output, SimpleChanges, OnChanges, ElementRef, ViewChild, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith} from 'rxjs/operators';
import { BasicWithLibelleModel } from 'src/app/shared/models/basic/basicWithLibelle.model';


@Component({
  selector: 'app-autocomplete-with-code',
  templateUrl: './autocomplete-with-code.component.html',
  styleUrls: ['./autocomplete-with-code.component.scss']
})
export class AutoCompleteWithCodeComponent implements OnChanges {

  @Input() objets: BasicWithLibelleModel[];
  @Input() objet: BasicWithLibelleModel;
  @Input() selectedObjet: BasicWithLibelleModel[];
  @Input() required: boolean;
  @Input() forbiddenNames: boolean;
  @Input() parent: UntypedFormGroup;
  @Input() formControlName: string;
  @Input() libelle: string;
  @Output() objetChange = new EventEmitter<BasicWithLibelleModel>();
  @Output() loadData =  new EventEmitter<string>();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;

  objetsString: string[] = [];
  filteredObjets: Observable<string[]>;
  myControl = new UntypedFormControl();

  constructor() {}

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets) {
      this.objets = [...new Map(this.objets.map(item => [item.code + '-' + item.libelle, item])).values()];
      for (const objet of this.objets) {
        this.objetsString.push(objet.code + '-' + objet.libelle);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString.slice(0, 30)));
      const validators = [];
      if (this.forbiddenNames) {
        validators.push(forbiddenNamesValidator(this.objets));
      }
      if (this.required) {
        validators.push(Validators.required);
      }
      this.myControl.setValidators(validators);
    } else {
      combineLatest([this.myControl.valueChanges])
      .subscribe(([value]) => {
        if (value.length > 1) {
          this.loadData.emit(value);
        } else {
          this.loadData.emit(null);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reLoadObjets();
    if(this.objet && changes.objet && (this.myControl.value !== this.objet.code + '-' + this.objet.libelle)) {
      this.myControl.setValue(this.objet.code + '-' + this.objet.libelle);
    }
    if (changes.objet && !changes.objet.currentValue) {
      this.myControl.setValue('');
    }
  }

  deleteIfEmptyOrNotFound(): void {
    this.myControl.setValue('');
    this.objet = null;
    this.objetChange.emit(null);
  }

 /* selected event MatAutocompleteSelectedEvent*/
  onObjetChange(value: string): void {
    let objet;
    if (value === '') {
      objet = null;
      this.objet = null;
    } else {
      objet = this.objets.find(obj => obj.code + '-' + obj.libelle === value);
      if (objet) {
        this.myControl.setValue(objet.code + '-' + objet.libelle);
        this.objet = objet;
      }
    }
    this.objetChange.emit(objet);
    this.reLoadObjets();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
  }
}

export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}
